import { useState } from "react";
import "./checkbox.css";

export const Checkbox = ({isChecked, onClick}) => {
      const [isCheckedState, setIsCheckedState] = useState(isChecked);

     const onHandleClick = () => {
       setIsCheckedState((prev) => !prev);
       onClick();
     };

  return (
    <div className="checkbox" onClick={onHandleClick}>
      <input
        className={isChecked ? "checked" : ""}
        type="checkbox"
        checked={isCheckedState}
        onChange={() => setIsCheckedState((prev) => !prev)}
      />
    </div>
  );
};
